import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  autoBet, cashOutBet, getAllBets, getBetHistory, getPreviousRoundState, getTopBets, openTile, placeBet
} from '../services/bbCross.services'
import { setRoundResult } from './bbCrossGame.slice'
import { BET_RESULT } from 'utils/constants/index'
import { birdFlyAnim, flowerShow, frogJump } from '../GameTheme/BbCross/PixiGame/bbCross/bridge'
import { openSuccessToaster } from '../../helpers/toaster.helpers'
import { isApiFetching, isChickenReached, isFrogDie } from '../GameTheme/BbCross/PixiGame/bbCross/store'
import { cashOutSfx, clickSfx, JumpSfx, lostSfx } from '../GameTheme/BbCross/PixiGame/bbCross/soundManager'

export const getBbCrossGamePreviousRoundState = createAsyncThunk(
  'crossGame/get-previous-round-state', async (_, thunkApi) => {
    try {
      const res = await getPreviousRoundState()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const getMyBetsMineGame = createAsyncThunk(
  'crossGame/get-my-bets', async (data, thunkApi) => {
    try {
      const res = await getBetHistory(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const bbCrossGamePlacedBet = createAsyncThunk(
  'crossGame/place-bet', async ({ payload }, thunkApi) => {
    try {
      const res = await placeBet(payload)
      const { gameSound } = thunkApi?.getState()?.gameSetting
      gameSound && clickSfx?.play()
      openSuccessToaster({ message: 'Bet Placed!' })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const foggyCrossGameAutoBet = createAsyncThunk(
  'crossGame/auto-bet', async ({ payload, isInstantBetEnabled }, thunkApi) => {
    try {
      const res = await autoBet(payload)
      const { gameSound } = thunkApi?.getState()?.gameSetting

      gameSound && clickSfx?.play()
      const resetGameInSecond = isInstantBetEnabled ? 600 : 1200
      setTimeout(() => {
        if (res?.result === BET_RESULT.LOST) {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        } else {
          thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
        }
      }, resetGameInSecond)

      if (gameSound) {
        res?.result === BET_RESULT.WON ? cashOutSfx?.play() : mineTileAudio?.play()
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const bbGameOpenTile = createAsyncThunk(
  'crossGame/opened-tile', async (payload, thunkApi) => {
    try {
      isChickenReached.value = false
      isApiFetching.value = true
      frogJump(true)
      const { tile, isInstantBetEnabled } = payload
      const { gameSound } = thunkApi?.getState()?.gameSetting
      const res = await openTile({ tile })

      if (res?.mineTile) {
        isFrogDie.value = true
        const resetGameInSecond = isInstantBetEnabled ? 400 : 800
        setTimeout(() => {
          gameSound && lostSfx?.play()
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        }, resetGameInSecond)
      } else {
        isFrogDie.value = false
        gameSound && JumpSfx?.play()
      }
      isApiFetching.value = false

      if (isChickenReached.value) {
        res?.mineTile ? birdFlyAnim() : flowerShow()
      }
      res.tile = payload.tile
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const bbCrossGameCashOut = createAsyncThunk(
  'crossGame/cash-out', async ({ isInstantBetEnabled }, thunkApi) => {
    try {
      const res = await cashOutBet()
      const { gameSound } = thunkApi?.getState()?.gameSetting
      openSuccessToaster({ message: 'Cashout successful' })
      const resetGameInSecond = isInstantBetEnabled ? 600 : 1200
      setTimeout(() => {
        thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
      }, resetGameInSecond)
      gameSound && cashOutSfx?.play()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const bbCrossGameTopBets = createAsyncThunk(
  'crossGame/top-bets', async (_, thunkApi) => {
    try {
      const res = await getTopBets()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const bbCrossGameAllBets = createAsyncThunk(
  'crossGame/all-bets', async (_, thunkApi) => {
    try {
      const res = await getAllBets()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const verifyProvableFairMine = createAsyncThunk('crash-game/check-provable-fair', async (payload, thunkApi) => {
  try {
    const res = await verifyProvableFairMine(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
